import React from 'react'

const VIDEOS = [
  {
    title: 'Репрайсер',
    description:
      'Как автоматически управлять ценами на\u00A0маркетплейсах с\u00A0помощью Прайс Ниндзя',
    url: 'https://rutube.ru/video/a77fb367c6e9625b1c51236b4d424f66/',
    embedUrl: 'https://rutube.ru/play/embed/a77fb367c6e9625b1c51236b4d424f66'
  },
  {
    title: 'Мониторинг цен',
    description:
      'Как отслеживать цены и контролировать РРЦ на\u00A0маркетплейсах',
    url: 'https://rutube.ru/video/989529a5572de35c537490cac6f46fef/',
    embedUrl: 'https://rutube.ru/play/embed/989529a5572de35c537490cac6f46fef'
  }
]

const PlayButton = () => (
  <span className="flex h-14 w-[92px] items-center justify-center rounded-full bg-[#0A25FF] transition-colors group-hover:bg-[#263FFF] lg:h-20 lg:w-[136px]">
    <svg
      width="26"
      height="30"
      viewBox="0 0 26 30"
      fill="none"
      aria-hidden="true"
    >
      <path d="M25 15L1 29V1L25 15Z" fill="white" />
    </svg>
  </span>
)

const VideoCard = ({ video, onSelect }) => (
  <button
    type="button"
    className="group flex w-full flex-col rounded-[20px] bg-[#1B2126] p-5 text-center transition-colors hover:bg-[#20272E] lg:rounded-[60px] lg:p-10 lg:pb-[60px]"
    aria-label={`Открыть видео: ${video.title}`}
    onClick={() => onSelect(video)}
  >
    <span className="relative block aspect-[5/3] w-full overflow-hidden rounded-[20px] border border-[#3C4652] lg:rounded-[22px]">
      <img
        src="/video-modal-image-new.png"
        alt=""
        className="h-full w-full object-cover"
      />
      <span className="absolute inset-0 bg-[rgba(1,8,25,0.22)] transition-colors group-hover:bg-[rgba(1,8,25,0.08)]" />
      <span className="absolute inset-0 flex items-center justify-center">
        <PlayButton />
      </span>
    </span>
    <span className="mt-8 block text-lg font-medium text-white lg:mt-10 lg:text-2xl">
      {video.title}
    </span>
    <span className="mx-auto mt-4 block max-w-[520px] text-base font-normal leading-6 text-[#919BA0] lg:mt-5 lg:text-lg lg:leading-7">
      {video.description}
    </span>
  </button>
)

const VideoSection = ({ onVideoSelect }) => (
  <section className="bg-[#02070D] px-5 lg:py-20 py-5">
    <div className="mx-auto grid max-w-[1200px] grid-cols-1 gap-5 lg:grid-cols-2">
      {VIDEOS.map(video => (
        <VideoCard key={video.url} video={video} onSelect={onVideoSelect} />
      ))}
    </div>
  </section>
)

export { VideoSection }
